/* eslint-disable import/prefer-default-export */
import { RSqualitelSchema_Type } from '@batical/types/src'

const Data = require('../json/Squalitel.json')

//CoefficientMajorationBatimentSorted

export function fetchQualitelWithDTU(dtu: number): RSqualitelSchema_Type | null {
  //specifc case becasue database s bullshit
  if (dtu === 0) {
    return Data.filter((item: RSqualitelSchema_Type) => item.uuid === 'NB0')[0]
  }
  const result = Data.filter((item: RSqualitelSchema_Type) => item.min <= dtu && dtu < item.max)
  if (result.length > 0) {
    return result[0]
  } else {
    return null
  }
}
